(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pxu-announcement-slider"] && !Shopify.designMode) return;
  try {
    
const { Section, Carousel } = window.PxuThemeSections;

class AnnouncementSliderSection extends Section {
  constructor($root) {
    super($root);
    this.$root = $root;
    this.id = $root.id;
    this.data = this.loadData();
    this.carousel = null;
    this.resizeTimeout = null;
    this.showArrows = this.data.show_arrows;
    this.observers = []; 
    this.onMount();
  }

  onMount() {
    if (!this.data.hasSlider) return;

    this.$root.classList.remove('pxu-announcement-slider--initialized');

    const options = {
      prevNextButtons: true,
      pageDots: false,
      groupCells: false,
      cellAlign: 'left',
      wrapAround: true,
      autoPlay: this.data.auto_rotate ? this.data.rotation_speed * 1000 : false,
    };

    this.carousel = new Carousel(this.$root, options);
    this.carousel.onMount();

    setTimeout(() => {
      this.adjustNavigationButtons();
      this.toggleButtonVisibility(this.showArrows);
      this.$root.classList.add('pxu-announcement-slider--initialized'); 
    }, 0);
  
    this.initEventListeners();
  }

  waitForElement(selector, callback) {
    const element = this.$root.querySelector(selector);
    
    if (element) {
      callback(element);
      return;
    }

    const observer = new MutationObserver((mutations, obs) => {
      const element = this.$root.querySelector(selector);
      if (element) {
        obs.disconnect();
        callback(element);
        this.observers = this.observers.filter(o => o !== obs); 
      }
    });

    observer.observe(this.$root, { childList: true, subtree: true });
    this.observers.push(observer); 
  }

  initEventListeners() {
    this.events.register(window, 'resize', () => {
      this.toggleButtonVisibility(false);
      clearTimeout(this.resizeTimeout);

      this.resizeTimeout = setTimeout(() => {
        this.adjustNavigationButtons();
        this.toggleButtonVisibility(this.showArrows);
      }, 200);
    });

    this.events.register(window, 'load', () => {
      this.adjustNavigationButtons();
      this.toggleButtonVisibility(this.showArrows);
    });

    this.events.register(document, 'keydown', (event) => {
      if (event.key === 'Tab') {
        this.toggleButtonVisibility(true);
      }
    });

    this.events.register(document, 'click', (event) => {
      if (this.showArrows === false && !event.target.closest('.flickity-prev-next-button')) {
        this.toggleButtonVisibility(false);
      }
    });

    this.toggleButtonVisibility(false);
  }

  toggleButtonVisibility(visible) {
    this.waitForElement('.flickity-prev-next-button', () => {
      const buttons = this.$root.querySelectorAll('.flickity-prev-next-button');
      buttons.forEach(button => {
        button.style.transition = visible ? 'opacity 0.2s ease-out' : 'none';
        button.style.opacity = visible ? '1' : '0';
        button.style.pointerEvents = visible ? 'auto' : 'none';
      });
    });
  }

  adjustNavigationButtons() {
    this.waitForElement('.flickity-prev-next-button', () => {
      const prevButton = this.$root.querySelector('.flickity-prev-next-button.previous');
      const nextButton = this.$root.querySelector('.flickity-prev-next-button.next');
      const announcements = this.$root.querySelectorAll('.pxu-announcement-slider__text');
      const viewport = window.innerWidth;
      const container = this.$root.querySelector('.pxu-section__container');

      if (!announcements.length || !container) return;

      let maxWidth = 0;
      announcements.forEach((el) => {
        const width = el.getBoundingClientRect().width;
        maxWidth = Math.max(maxWidth, width);
      });

      const containerRect = container.getBoundingClientRect();
      const minWidth = 650;
      let buttonOffset = 8;

      if (viewport >= 860) {
        const containerLeftEdge = containerRect.left;
        const containerRightEdge = viewport - containerRect.right;
        const announcementMaxWidth = maxWidth;
        const announcementLeftEdge = containerLeftEdge + (containerRect.width - announcementMaxWidth) / 2;
        const announcementRightEdge = containerRightEdge + (containerRect.width - announcementMaxWidth) / 2;

        if (maxWidth <= minWidth) {
          const leftGap = (announcementLeftEdge - containerLeftEdge) / 2;
          const rightGap = (containerRightEdge - announcementRightEdge) / 2;
          const maxOffset = Math.min(leftGap, rightGap);
          buttonOffset = maxOffset;
        }
      }

      prevButton.style.left = `${-buttonOffset}px`;
      nextButton.style.right = `${-buttonOffset}px`;
    });
  }

  onUnmount() {
    if (!this.carousel) return;
    this.carousel.onUnmount();
    this.carousel = null;
    this.events.unregisterAll();
    this.observers.forEach(observer => observer.disconnect());
    this.observers = [];
  }

  onBlockSelect(event) {
    if (!this.carousel) return;
    const $slide = event.target.parentElement;
    this.carousel.selectSlide($slide);
  }
}

document.querySelectorAll('[data-pxu-announcement-slider]').forEach(($section) => {
  Section.init($section, AnnouncementSliderSection);
});

if (Shopify.designMode) {
  window.PxuThemeSections.AnnouncementSliderSection = AnnouncementSliderSection;
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pxu-countdown-timer-bar"] && !Shopify.designMode) return;
  try {
    
const { Section } = window.PxuThemeSections;

class CountdownTimerBarSection extends Section {
  constructor($root) {
    super($root);
    this.$root = $root;
    this.id = $root.id;
    this.data = this.loadData();
    this.countdown = this.query('[data-pxu-countdown-timer-bar-countdown]');
    this.days = this.query('[data-pxu-countdown-timer-bar-countdown-day]');
    this.hours = this.query('[data-pxu-countdown-timer-bar-countdown-hrs]');
    this.minutes = this.query('[data-pxu-countdown-timer-bar-countdown-min]');
    this.seconds = this.query('[data-pxu-countdown-timer-bar-countdown-sec]');
    this.dateTime = this.data.countdownDatetime;

    this.targetDate = this.dateTime ? Date.parse(this.dateTime) : null;
    this.daysInMs = 1000 * 60 * 60 * 24;
    this.hoursInMs = this.daysInMs / 24;
    this.minutesInMs = this.hoursInMs / 60;
    this.secondsInMs = this.minutesInMs / 60;
    this.timeoutId = null;
    this.isLoading = true;

    this.onMount();
  }

  onMount() {
    this.startTimer();
  }

  onUnmount() {
    this.stopTimer();
  }
  updateLoadingState() {
    // Remove the loading class once the countdown is ready.
    this.countdown.classList.remove('pxu-countdown-timer__countdown--loading');
  }

  startTimer() {
    const interval = 1000;
    let expectedTime = Date.now() + interval;

    // If the target date has already passed, handle countdown completion.
    if (this.targetDate <= Date.now()) {
      this.updateLoadingState();
      this.handleCountDownComplete();
      return;
    }

    const countDown = () => {
      const currentDate = Date.now();
      const timeDiff = this.targetDate - currentDate;

      // If time difference is zero or less, stop the timer and handle countdown completion.
      if (timeDiff <= 0) {
        this.stopTimer();
        this.handleCountDownComplete();
        return;
      }

      // Convert the time difference, calculate the drift, and adjust the expected time.
      const remainingTime = this.convertTime(timeDiff);
      const drift = currentDate - expectedTime;
      expectedTime += interval;

      // Update the loading state and update the DOM with the remaining time.
      if (this.isLoading) this.updateLoadingState();
      this.updateDom(remainingTime);

      this.timeoutId = setTimeout(countDown, Math.max(0, interval - drift));
    };

    this.timeoutId = setTimeout(countDown, interval);
  }

  stopTimer() {
    // Stop the countdown and clear the timeout.
    clearTimeout(this.timeoutId);
  }

  convertTime(timeInMs) {
    // Convert the time difference into days, hours, minutes, and seconds.
    const days = parseInt(timeInMs / this.daysInMs, 10);
    timeInMs -= days * this.daysInMs;

    const hours = parseInt(timeInMs / this.hoursInMs, 10);
    timeInMs -= hours * this.hoursInMs;

    const minutes = parseInt(timeInMs / this.minutesInMs, 10);
    timeInMs -= minutes * this.minutesInMs;

    const seconds = parseInt(timeInMs / this.secondsInMs, 10);

    // Return an object with the calculated time.
    return { days, hours, minutes, seconds };
  }

  updateDom(dateObj) {
    // Update DOM elements with the remaining time.
    const { days, hours, minutes, seconds } = dateObj;
    this.days.textContent = days;
    this.hours.textContent = hours;
    this.minutes.textContent = minutes;
    this.seconds.textContent = seconds;
  }

  handleCountDownComplete() {
    // Update the DOM once the countdown is complete.
    this.updateDom({
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
    });

    // Add the complete class once the countdown is complete.
    this.countdown.classList.add('pxu-countdown-timer-bar__countdown--complete');
  }
}

document.querySelectorAll('[data-pxu-countdown-timer-bar]').forEach(($section) => {
  Section.init($section, CountdownTimerBarSection);
});

// export class for theme editor instance management
if (Shopify.designMode) {
  window.PxuThemeSections.CountdownTimerBarSection = CountdownTimerBarSection;
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pxu-highlights-banner"] && !Shopify.designMode) return;
  try {
    
const { Section, Carousel } = window.PxuThemeSections;
class HighlightsBannerSection extends Section {
  constructor($root) {
    super($root);
    this.$root = $root;
    this.id = $root.id;
    this.data = this.loadData();
    this.carousel = null;

    this.onMount();
  }

  onMount() {
    if (!this.data.hasSlider) return;
    this.carousel = new Carousel(this.$root, {
      draggable: true,
      cellAlign: 'left'
    });
    setTimeout(() => {
      this.carousel.onMount();
    }, 100);
  }

  onUnmount() {
    if (!this.carousel) return;
    this.carousel.onUnmount();
    this.carousel = null;
  }

  onBlockSelect(event) {
    if (!this.data.hasSlider || !this.carousel) return;
    const $slide = event.target.parentElement;
    this.carousel.selectSlide($slide);
  }
}

document.querySelectorAll(`[data-pxu-highlights-banner]`).forEach(($section) => {
  Section.init($section, HighlightsBannerSection);
});

// Export for theme editor instance management.
if (Shopify.designMode) {
  window.PxuThemeSections.HighlightsBannerSection = HighlightsBannerSection;
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pxu-logo-list"] && !Shopify.designMode) return;
  try {
    
const { Section, Carousel } = window.PxuThemeSections;
class LogoListSection extends Section {
  constructor($root) {
    super($root);
    this.$root = $root;
    this.id = $root.id;
    this.data = this.loadData();
    this.carousel = null;

    this.onMount();
  }

  onMount() {
    if (!this.data.hasSlider) return;
    this.carousel = new Carousel(this.$root, {
      draggable: true,
      groupCells: true,
      cellAlign: 'left'
    });
    setTimeout(() => {
      this.carousel.onMount();
    }, 100);
  }

  onUnmount() {
    if (!this.carousel) return;
    this.carousel.onUnmount();
    this.carousel = null;
  }

  onBlockSelect(event) {
    if (!this.data.hasSlider || !this.carousel) return;
    const $slide = event.target.parentElement;
    this.carousel.selectSlide($slide);
  }
}

document.querySelectorAll(`[data-pxu-logo-list]`).forEach(($section) => {
  Section.init($section, LogoListSection);
});

// Export for theme editor instance management.
if (Shopify.designMode) {
  window.PxuThemeSections.LogoListSection = LogoListSection;
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pxu-particle-banner"] && !Shopify.designMode) return;
  try {
    
const { Section } = window.PxuThemeSections;

function webgl_support() {
  try {
    var canvas = document.createElement('canvas');
    return !!window.WebGLRenderingContext &&
      (canvas.getContext('webgl') || canvas.getContext('experimental-webgl'));
  } catch (e) {
    return false;
  }
};

class ParticleBannerSection extends Section {
  constructor($root) {
    super($root);
    this.$root = $root;
    this.id = $root.id;
    this.data = this.loadData();
    this.container = this.$root.querySelector('[data-pxu-chladni]');

    if (webgl_support() && !Shopify.visualPreviewMode) {
      this.onMount()
    } else {
      this.$root.classList.add('pxu-particle-banner--unsupported');
    }
  }

  onMount() {
    const params = {
      clearColor: this.data.clearColor,
      textDesktop: this.data.textDesktop,
      textMobile: this.data.textMobile,
      textWidthDesktop: parseInt(this.data.textWidthDesktop, 10) / 100,
      textWidthMobile: parseInt(this.data.textWidthMobile, 10) / 100,
      color: this.data.color,
      fontFamily: this.data.fontFamily,
      aspectRatioMobile: this.data.aspectRatioMobile,
      aspectRatioDesktop: this.data.aspectRatioDesktop,
      duration: this.data.duration,
      lineHeight: parseFloat(this.data.lineHeight)
    };

    const loadChladni = () => {
      this.checkInterval = setInterval(() => {
        if (typeof window.PxuThemeSections?.Chladni === 'function') {
          clearInterval(this.checkInterval);
          this.chladni = new window.PxuThemeSections.Chladni(this.container, params, () => {
            const { bottomRight } = this.chladni.getTextBoxPercentCoordinates();
            this.$root.style.setProperty(
              '--pxu-section-height-under-text',
              `${100 - bottomRight.y}%`
            );
          });
        }
      }, 500);
    };

    loadChladni();
  }

  onUnmount() {
    clearInterval(this.checkInterval);
    this.events.unregisterAll();
    if (this.chladni) this.chladni.onUnmount();
  }
}

document.querySelectorAll('[data-pxu-particle-banner]').forEach(($section) => {
  Section.init($section, ParticleBannerSection);
});

// export class for theme editor instance management
if (Shopify.designMode) {
  window.PxuThemeSections.ParticleBannerSection = ParticleBannerSection;
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pxu-scrolling-text"] && !Shopify.designMode) return;
  try {
    
const { Section } = window.PxuThemeSections;
const { debounce } = window.PxuUtils;

class ScrollingTextSection extends Section {
  constructor($root) {
    super($root);
    this.$root = $root;
    this.id = $root.id;
    this.data = this.loadData();
    this.contentItems = this.$root.querySelectorAll('[data-scrolling-text-content]');

    this.onMount();
  }

  // Section lifecycle

  onMount() {
    this._initScroll();
  }

  _initScroll() {
    this.contentItems.forEach(el => {
      const textItems = el.querySelectorAll('[data-scrolling-text-content-item]');
      const width = el.offsetWidth;

      // Calculate the total width of all marquee items.
      const totalItemWidth = [...textItems].reduce((total, item) => total + item.offsetWidth, 0);

      // Calculate the number of marquee items needed to fill the container.
      const numItems = Math.ceil(width / totalItemWidth);

      // Clone and append marquee items.
      for (let i = 0; i < numItems; i++) {
        textItems.forEach(item => {
          const clone = item.cloneNode(true);
          el.appendChild(clone);
        });
      }
    });

    this._observeAnimations();
  }

  _observeAnimations() {
    // Initiate animations in viewport.
    this.observer = new IntersectionObserver(debounce(([entry]) => {
      const { isIntersecting } = entry;
      this.$root.classList.toggle('pxu-scrolling-text--is-animated', isIntersecting);
    }, 100));

    this.observer.observe(this.$root);
  }

  onUnmount(){
    this.observer.unobserve(this.$root);
  }
}

document.querySelectorAll('[data-pxu-scrolling-text]').forEach(($section) => {
  Section.init($section, ScrollingTextSection);
});

// export class for theme editor instance management
if (Shopify.designMode) {
  window.PxuThemeSections.ScrollingTextSection = ScrollingTextSection;
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pxu-shoppable-image"] && !Shopify.designMode) return;
  try {
    
const { Section } = window.PxuThemeSections;
const { debounce } = window.PxuUtils;

class Hotspot {
  OPEN_CLASS = "pxu-shoppable-image__hotspot--open";
  CLOSE_CLASS = "pxu-shoppable-image__hotspot--closed";

  constructor($el) {
    this.$hotspot = $el;
    this.$pin = $el.querySelector('[data-pxu-shoppable-image-pin]');
    this.isOpen = false;
  }

  open() {
    this.isOpen = true;
    this.$hotspot.classList.add(this.OPEN_CLASS);
  }

  close() {
    this.isOpen = false;
    this.$hotspot.classList.remove(this.OPEN_CLASS);
    this.$hotspot.classList.add(this.CLOSE_CLASS);
    setTimeout(() => {
      this.$hotspot.classList.remove(this.CLOSE_CLASS);
    }, 2000);
  }
}

class ShoppableImageSection extends Section {
  PIN_WIDTH = 30;

  constructor($root) {
    super($root);
    this.$root = $root;
    this.$interface = this.query('[data-pxu-shoppable-image-interface]');
    this.$hotspots = this.queryAll('[data-pxu-shoppable-image-hotspot]');
    this.$tooltips = this.queryAll('[data-pxu-shoppable-image-tooltip]');
    this.hotspots = [...this.$hotspots].map(($el) => new Hotspot($el));
    this.id = $root.id;
    this.data = this.loadData();

    this.onMount();
  }

  onMount() {
    this.initEventListeners();
    this.updateTooltipVw();
    this.updateHotspotAxes();
  }

  onUnmount() {
    this.events.unregisterAll();
  }

  initEventListeners() {
    this.hotspots.forEach((hotspot) => {
      this.events.register(hotspot.$hotspot, 'focusout', (e) => {
        this.handleHotspotFocusOut(e, hotspot);
      });
      this.events.register(hotspot.$pin, 'click', (e) => this.handlePinClick(e, hotspot));
    });
    this.events.register(window, 'resize', debounce(
      () => {
        this.updateTooltipVw();
        this.updateHotspotAxes();
      },
      200
    ));
  }

  handlePinClick(event, hotspot) {
    this.toggleTooltip(hotspot);
  }

  handleHotspotFocusOut(event, hotspot) {
    if (hotspot.$hotspot.contains(event.relatedTarget)) return;
    hotspot.$pin.dataset.timer = setTimeout(() => {
      hotspot.close();
    }, 0);
  }

  updateTooltipVw() {
    this.$tooltips.forEach(($tooltip) => {
      const vw = this.$root.offsetWidth;
      $tooltip.style.setProperty('--pxu-100vw', `${vw}px`);
    });
  }

  updateHotspotAxes() {
    this.$hotspots.forEach(($hotspot) => {
      let hAxis = $hotspot.style.getPropertyValue('--pxu-section-horizontal-axis-base');
      const interfaceWidth = this.$interface.offsetWidth;
      const pinWidth = this.PIN_WIDTH;
      const subAreaWidthFactor = (interfaceWidth - (pinWidth)) / interfaceWidth;
      hAxis = hAxis * subAreaWidthFactor;

      let vAxis = $hotspot.style.getPropertyValue('--pxu-section-vertical-axis-base');
      const interfaceHeight = this.$interface.offsetHeight;
      const pinHeight = this.PIN_WIDTH;
      const subAreaHeightFactor = (interfaceHeight - (pinHeight)) / interfaceHeight;
      vAxis = vAxis * subAreaHeightFactor;
      
      $hotspot.style.setProperty('--pxu-section-horizontal-axis', hAxis);
      $hotspot.style.setProperty('--pxu-section-vertical-axis', vAxis);
    });
  }

  toggleTooltip(hotspot) {
    if (hotspot.isOpen) {
      hotspot.$pin.blur();
      hotspot.close();
    } else {
      this.closeAllHotspots();
      hotspot.open();
    }
  }

  closeAllHotspots() {
    this.hotspots.forEach((hotspot) => hotspot.close());
  }

  onBlockSelect(event) {
    const { blockId } = event.detail;
    const hotspot = this.hotspots.find((hotspot) => hotspot.$hotspot.id === blockId);
    if (hotspot) hotspot.open();
  }

  onBlockDeselect(event) {
    const { blockId } = event.detail;
    const hotspot = this.hotspots.find((hotspot) => hotspot.$hotspot.id === blockId);
    if (hotspot) hotspot.close();
  }
}

document.querySelectorAll(`[data-pxu-shoppable-image]`).forEach(($section) => {
  Section.init($section, ShoppableImageSection);
});

// export for theme editor instance management
if (Shopify.designMode) {
  window.PxuThemeSections.ShoppableImageSection = ShoppableImageSection;
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pxu-testimonials"] && !Shopify.designMode) return;
  try {
    
const { Section, Carousel } = window.PxuThemeSections;

class TestimonialsSection extends Section {
  constructor($root) {
    super($root);
    this.$root = $root;
    this.id = $root.id;
    this.data = this.loadData();
    this.carousel = null;

    this.onMount();
  }

  onMount() {
    if (!this.data.hasSlider) return;

    const options = {
      prevNextButtons: true,
      groupCells: 3,
      cellAlign: 'left'
    };


    const mobileOptions = {
      draggable: true,
      cellAlign: 'left'
    };

    this.carousel = new Carousel(this.$root, options, mobileOptions);
    this.carousel.onMount();
  }

  onUnmount() {
    if (!this.carousel) return;
    this.carousel.onUnmount();
    this.carousel = null;
  }

  onBlockSelect(event) {
    if (!this.carousel) return;
    const $slide = event.target.parentElement;
    this.carousel.selectSlide($slide);
  }
}

document.querySelectorAll('[data-pxu-testimonials]').forEach(($section) => {
  Section.init($section, TestimonialsSection);
});

// export class for theme editor instance management
if (Shopify.designMode) {
  window.PxuThemeSections.TestimonialsSection = TestimonialsSection;
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pxu-video-banner"] && !Shopify.designMode) return;
  try {
    
const { Section } = window.PxuThemeSections;

class VideoBannerSection extends Section {
 constructor($root) {
   super($root);
   this.$root = $root;
   this.$video = this.query('.pxu-video-banner__video');
   this.id = $root.id;
   this.data = this.loadData();
   this.observer = null;

   this.onMount();
 }

 onMount() {
   this.initIntersectionObserver();
 }

 onUnmount() {
   if (this.observer) {
     this.observer.unobserve(this.$root);
   }
 }

 initIntersectionObserver() {
   this.observer = new IntersectionObserver((entries, observer) => {
     entries.forEach(entry => {
       if (entry.isIntersecting) {
         if (this.$video) {
           this.initShopifyVideo();
         }
         observer.unobserve(this.$root);
       }
     });
   }, { threshold: 0 });
   this.observer.observe(this.$root);
 }

 initShopifyVideo() {
   if (!this.$video) return;
   const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

   if(prefersReducedMotion){
    this.$video.removeAttribute('autoplay');
    this.$video.setAttribute('controls', '');
   } else {
    this.$video.play();
   }
 }
}

document.querySelectorAll('[data-pxu-video-banner]').forEach(($section) => {
 Section.init($section, VideoBannerSection);
});

if (Shopify.designMode) {
 window.PxuThemeSections.VideoBannerSection = VideoBannerSection;
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pxu-video-with-text"] && !Shopify.designMode) return;
  try {
    
const { Section } = window.PxuThemeSections;

class VideoWithTextSection extends Section {
  constructor($root) {
    super($root);
    this.$root = $root;
    this.$shopifyVideo = this.query('.pxu-video-with-text__video');
    this.id = $root.id;
    this.data = this.loadData();
    this.observer = null;

    this.onMount();
  }

  onMount() {
    if (this.$shopifyVideo) this.initIntersectionObserver();
  }

  onUnmount() {
    if (this.$shopifyVideo) this.observer.unobserve(this.$root);
  }


  initIntersectionObserver() {
    this.observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.initVideo();
          observer.unobserve(this.$root);
        }
      });
    }, { threshold: 0 });
    this.observer.observe(this.$root);
  }

  initVideo() {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) {
      this.$shopifyVideo.setAttribute('controls', '');
    } else if (this.data.enableVideoAutoplay) {
      this.$shopifyVideo.play();
    }
  }
}

document.querySelectorAll('[data-pxu-video-with-text]').forEach(($section) => {
  Section.init($section, VideoWithTextSection);
});

// export class for theme editor instance management
if (Shopify.designMode) {
  window.PxuThemeSections.VideoWithTextSection = VideoWithTextSection;
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pxu-video"] && !Shopify.designMode) return;
  try {
    
const { Section } = window.PxuThemeSections;

class VideoSection extends Section {
  constructor($root) {
    super($root);
    this.$root = $root;
    this.$overlay = this.query('[data-pxu-video-overlay]');
    this.$btn = this.query('[data-pxu-video-btn]');
    this.$shopifyVideo = this.query('.pxu-video__video');
    this.id = $root.id;
    this.data = this.loadData();
    this.observer = null;

    this.onMount();
  }

  onMount() {
    this.initEventListeners();
    this.initIntersectionObserver();
  }

  onUnmount() {
    this.events.unregisterAll();
    this.observer.unobserve(this.$root);
  }

  initEventListeners() {
    if (this.$btn) {
      this.events.register(this.$btn, 'click', (e) => this.handleClick(e));
    }
  }

  initIntersectionObserver() {
    this.observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.initVideo();
          observer.unobserve(this.$root);
        }
      });
    }, { threshold: 0 });
    this.observer.observe(this.$root);
  }

  handleClick(e) {
    e.preventDefault();
    this.$overlay.style.opacity = 0;
    this.$overlay.style.pointerEvents = 'none';

    if (this.data.videoType === 'youtube') {
      const $video = this.query('[data-pxu-video-youtube');
      $video.src += '&autoplay=1';
    } else if (this.data.videoType === 'vimeo') {
      const $video = this.query('[data-pxu-video-vimeo]');
      $video.src += '&autoplay=1';
    } else if (this.data.videoType === 'shopify_hosted') {
      this.$shopifyVideo.play();
      this.$shopifyVideo.setAttribute('controls', '');
    }
  }

  initVideo() {
    switch (this.data.videoType) {
      case 'youtube':
        this.initYouTube();
        break;
      case 'vimeo':
        this.initVimeo();
        break;
      case 'shopify_hosted':
        if (this.data.enableVideoAutoplay) {
          this.$shopifyVideo.play();
        }
        break;
      default:
        console.error('Unsupported video type:', this.data.videoType);
    }
  }

  initYouTube() {
    if (this.data.videoType !== 'youtube') return;
    const $ytPlaceholder = this.query('[data-youtube-placeholder]');
    const ytAttributeString = $ytPlaceholder.dataset.attributeString;
    const ytTitle = $ytPlaceholder.dataset.title;
    $ytPlaceholder.innerHTML = `
      <iframe
        class="pxu-video__video"
        src="https://www.youtube.com/embed/${this.data.videoId}?${ytAttributeString}"
        allow="autoplay; encrypted-media"
        allowfullscreen
        title="${ytTitle}"
        data-pxu-video-youtube
      ></iframe>
    `;
  }

  initVimeo() {
    if (this.data.videoType !== 'vimeo') return;
    const $vimeoPlaceholder = this.query('[data-vimeo-placeholder]');
    const vimeoAttributeString = $vimeoPlaceholder.dataset.attributeString;
    $vimeoPlaceholder.innerHTML = `
      <iframe
        class="pxu-video__video"
        src="https://player.vimeo.com/video/${this.data.videoId}?${vimeoAttributeString}"
        allow="autoplay; encrypted-media"
        allowfullscreen
        data-pxu-video-vimeo
      ></iframe>
    `;
  }
}

document.querySelectorAll('[data-pxu-video]').forEach(($section) => {
  Section.init($section, VideoSection);
});

// export class for theme editor instance management
if (Shopify.designMode) {
  window.PxuThemeSections.VideoSection = VideoSection;
}

  } catch(e) { console.error(e); }
})();
})();
